import terms from './terms-en';
import policy from './policy-en';

export default {
  emailAddress: 'Email',
  confimEmailAddress: 'Email bestätigen',
  password: 'Passwort',
  confimPassword: 'Password bestätigen',
  changePassword: 'Password bestätigen',
  register: 'Registrieren',
  accountExists: 'Diese Email wird bereits verwendet',
  forgotPassword: 'Passwort vergessen?',
  registedGoTologin: 'Bereits registriert? Login',
  successfulRegistration: 'Registrierung erfolgreich!',
  activationtEmailSent: 'Eine Aktivierungsemail wurde versandt.',
  continue: 'Fortfahren',
  email: 'Email',
  login: 'Login',
  info:
    'The eVisa Burkina Faso is an electronic travel authorization issued by the government of Burkina Faso. eVisa is an entry requirement to travel to and within Burkina Faso. The Burkinabe eVisa is for touristic or family purpose. Visitors who enter Burkina Faso are required to present a valid eVisa at the port of entry',
  application: 'Antrag',
  submitDocs: 'Dokumente übermitteln',
  privacyPayment: 'Datenschutz Zahlung',
  approval: 'Bestätigung',
  termsAndConditions: 'Allgemeine Geschäftsbedingungen',
  privacyPolicy: 'Datenschutzerklärung',
  ministry: '© {{year}} eVisa-Ministry of Security',
  registerYet: 'Noch nicht registriert?',
  alreadyRegistered: 'Bereits registriert?',
  newApplication: 'Neuer Antrag',
  myApplications: 'Mein Antrag',
  applicationId: 'Antrags ID',
  applicationName: 'Antragssteller (Vollständiger Name)',
  status: 'Status',
  submissionDate: 'Einreichungsdatum',
  actions: 'Aktionen',
  view: 'Öffnen',
  resume: 'Fortsetzen',
  respondToVisaOfficer: 'Visa Officer antworten',
  messageToApplicant: 'Mitteilung an den Antragssteller', // to be translated
  applicationForm: 'Antragsformular',
  back: 'Zurück',
  backTo: 'Zurück zu den Anträgen',
  saveAndContinue: 'Speichern & Fortfahren',
  supportingDocs: 'Beiliegende Dokumente',
  docType: 'Dokumenttyp',
  filename: 'Dateiname',
  uploadMax: 'Hochladen',
  declarationAndPayment: 'Erklärung und Zahlung',
  proceedTo: 'Fortfahren mit Zahlung',
  declarationOfApplicant: 'Erklärung des Antragstellers',
  checkBox1:
    "Ich erkläre die Richtigkeit der in dieser Anfrage gemachten Angaben und übernehme die Verantwortung für eventuelle Eingabefehler.",
  checkBox2:
    "Ich bin darüber informiert, dass die Visumgebühren im Falle einer Ablehnung nicht erstattet werden. Sehen.",
  checkBox2And: 'und',
  secureCardPayment: 'Sichere Kartenzahlung',
  submitPayment: 'Zahlung einreichen',
  summary: 'Zusammenfassung:',
  firstName: 'Vorname:',
  familyName: 'Nachname:',
  passportNumber: 'Reisepassnummer:',
  paymentReceiptNumber: 'Zahlungsvorgangsnummer', // to be translated
  payment: 'Zahlung:',
  totalAmount: 'Gesamtbetrag:',
  paymentNotSuccessful: 'Die Zahlung ist fehlgeschlagen.',
  pleaseGoBack:
    'Bitte gehen Sie zurück zu den Zahlungsoptionen und wählen Sie eine andere Methode.',
  goToApplications: 'Zu den Antragen',
  paymentSuccessful: 'Zahlung erfolgreich.',
  applicationSuccessful: 'Bewerbung ist erfolgreich',
  applicationSubmitted:
    'Ihr Visumantrag wurde erfolgreich an den Visumsbeauftragten zur Bearbeitung und Freigabe übermittelt. Sie erhalten eine E-Mail, die Sie über das Ergebnis informiert, nachdem das Visum bearbeitet wurde.',
  shortcode: 'Visa Code:', // to be translated
  print: 'Drucken', // to be translated
  whatsNext: 'Nächste Schritte',
  applicationTracked: 'Der Status kann auf der Antragsliste verfolgt werden.',
  visaDetails: 'Visum Daten',
  personalDetails: 'Persönliche Daten',
  passportDetails: 'Reisepass Daten',
  travelDetails: 'Reisedaten',
  contactDetails: 'Kontakt Details',
  address: 'Addresse',
  homeAddress: 'Privatadresse',
  emergencyContact: 'Notfallkontakt',
  paymentSubtitle: 'Zahlung',
  visaFee: 'Visumsgebühr:',
  totalAmount2: 'Gesamtbetrag:',
  send: 'Übermitteln',
  passwordSuccessfullyChanged: 'Das Passwort wurde erfolgreich geändert.',
  ok: 'Ok',
  emailResetPassword:
    'Sie haben eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts erhalten.',
  visaType: 'Visa-Typ',
  visaPurpose: 'Visumszweck',
  nationality: 'Staatsangehörigkeit',
  surname: 'Nachname',
  firstGivenNames: 'Vornamen',
  dateBirth: 'Geburtsdatum',
  gender: 'Geschlecht',
  countryBirth: 'Geburtsland',
  cityBirth: 'Geburtsstadt',
  relantionship: 'Beziehungsstatus',
  occupation: 'Beruf',
  numberChildren: 'Anzahl Kinder',
  passportNumber2: 'Reisepassnummer',
  placeIssue: 'Ausstellungsort',
  passportType: 'Reisepass-Typ',
  passportExpiry: 'Ablaufdatum',
  passportIssue: 'Ausstellungsdatum',
  portEntry: 'Einreisehafen',
  intendedDate:
    'Geplanter Eintrittstermin (Geben Sie einen Zeitraum von 7 Tagen vor dem geplanten Einreisedatum an.)',
  maximumStay: 'Maximale Aufenthaltsdauer (Tage)',
  destinationAddress: 'Addresse in',
  nameAndNumberIn:
    'Vollständiger Name, Telefonnummer des Korrespondenten in',
  modesTransport: 'Transport',
  destinations: 'Ziele',
  mobileCellPhone: 'Handy',
  email2: 'Email Addresse',
  street: 'Straße',
  city: 'Stadt',
  state: 'Bundesland',
  postalCode: 'Postleitzahl',
  countryResidence: 'Wohnsitz',
  fullName: 'Vollständiger Name',
  phoneNumber: 'Telefon-Nummer',
  paymentMethod: 'Zahlungsart auswählen',
  payment_method: 'Zahlmethode', // to be translated
  paidAt: 'Zahldatum', // to be translated
  submitter: 'Antragsübermittler', // to be translated
  cardName: 'Name des Karteninhabers',
  cardNumber: 'Kartennummer',
  expirationDate: 'Ablaufsdatum:',
  month: 'Monat',
  year: 'Jahr',
  cvv: 'CVV',
  unspecified: 'Nicht spezifiziert',
  supportingDocumentsCaption:
    "Die mit einem '*' gekennzeichneten Dokumente sind erforderlich.",
  maxFileSizeSupporting:
    'Geben Sie einen der folgenden Bilddateitypen an: JPG, JPEG, PNG, TIFF, BMP, DOC, DOCX, PDF bis zu 1 MB.',
  eitherOrDocSelectionPrompt: 'Dokumenttyp auswählen',
  cancel: 'Abbrechen',
  or: 'Oder',
  close: 'Schließen',
  expiredSessionTitle: 'Die Sitzung ist abgelaufen',
  expiredSessionText:
    'Die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an',
  404: 'Die gesuchte Seite wurde nicht gefunden.',
  home: 'Home',
  onlineServices: 'Online-Visa-Service',
  eVisa: 'eVisa',
  enterEmailAddress: 'E-Mail-Adresse eingeben',
  resetPassword: 'Passwort zurücksetzen',
  applicationID: 'Antrags ID:',
  shortCode: 'Visa Code', // to be translated
  uploadPaymentReceiptScan: 'Quittung hochladen', // to be translated
  applicationDate: 'Antragsdatum:',
  applicationNAME: 'Antragsname:',
  visaP: 'Visumszweck:',
  startWritingResponse: 'Beginnen Sie hier, Ihre Antwort zu schreiben.',
  hotelOrContact: 'Hotel- oder Kontaktname',
  passwordResetConfirmation: 'Ihr Passwort wurde zurückgesetzt.',
  resetPasswordNewPasswordTitle: 'Neues Passwort erstellen',
  requestResetPasswordTitle: 'Passwort zurücksetzen',
  registrationTitle: 'Registrierung',
  awaitingFeedbackTitle: 'Feedback erwartet',
  logInTitle: 'Log in',
  applicationSummaryTitle: 'Zusammenfassung:',
  unableToLogin: 'Anmeldung nicht möglich',
  pageNotFound: 'Seite nicht gefunden',
  yourApplicationID: 'Ihre Antrags ID:',
  emailSentTo: 'Eine E-Mail wurde gesendet an ',
  withApplicationID: ' mit der Antrags ID',
  unknownError: 'Es ist ein unbekannter Fehler aufgetreten',
  SERVER_ERROR: 'Es ist ein unbekannter Server Fehler aufgetreten',
  TIMEOUT_ERROR: 'Timeoutfehler',
  CONNECTION_ERROR: 'Fehler beim Verbinden zum Server',
  NETWORK_ERROR: 'Fehler beim Verbinden zum Server durch Netzwerkprobleme',
  CANCEL_ERROR: 'Abgebrochen',
  supportingTypesCaption:
    'Es werden nur Datein mit den Endungen (.doc/.pdf/.jpg) are akzeptiert',
  mustBeAfterToday: 'Bitte geben Sie ein passendes Datum ein',
  mustBeOnOrAfterToday: 'Bitte geben Sie ein passendes Datum ein',
  mustBeOnOrBeforeToday: 'Bitte geben Sie ein passendes Datum ein',
  attachedFiles: 'Anhang',
  chooseFile: 'Datei auswählen',
  unsupportedDocType:
    'Nicht unterstützte Dateiformate. Die folgenden Formate werden unterstützt: {{fileTypes}}',
  unsupportedImageFileType:
    'Nicht unterstützte Dateiformate. Die folgenden Formate werden unterstützt: {{pictureFileTypes}}',
  imageFileTypeLabel:
    'Dokumente in den folgenden Formaten können hochgeladen werden: {{pictureFileTypes}}. Die maximale Dateigröße beträgt 1MB.',
  fileTypeLabel:
    'Dokumente in den folgenden Formaten können hochgeladen werden: {{fileTypes}}. Die maximale Dateigröße beträgt 1MB.',
  maxFileSizeExceeded:
    'Maximale Dateigröße überschritten. Bitte stellen Sie sicher, dass die Datei nicht größer als 1 MB ist.',
  mustBeBeforePassportExpireDate:
    'Das ausgewählte Datum muss vor dem Ablaufdatum des Reisepasses liegen',
  clear: 'Bereinigen', // to be translated
  apply: 'Anwenden', // to be translated
  sendPaymentLink: 'Bezahllink senden', // to be translated
  paymentLinkSent: 'Beazahllink wurde an den Antragssteller versandt', // to be translated
  pleaseWait: 'Bitte warten', // to be translated
  serviceFee: 'Bearbeitungsgebühr: {{amount}} {{currency}}', // to be translated
  costOfVisa: 'Visagebühr: {{amount}} {{currency}}', // to be translated
  totalPaymentAmount: 'Zahlbetrag: {{amount}} {{currency}}', // to be translated
  'Pay at Embassy': 'Zahlung in Botschaft', // to be translated
  rowsPerPage: 'Zeilen pro Seite',
  finishPay: 'Zahlung anwenden',
  diplomaticMission: 'Diplomatische Organisation',
  filter: {
    shortCode: 'Visa Code',
    lastName: 'Nachname',
    status: 'Status',
    submitter: 'Übermittelt durch',
    visaForLocalPayment: 'Visa für Vor-Ort Zahlung',
    submittedDateFrom: 'Antragsdatum (Von)',
    submittedDateTo: 'Antragsdatum (Bis)',
  },
  paymentInfo: {
    header: 'Bezahlung ausstehend', // to be translated
    appId: 'Antragsnummer: ', // to be translated
    description:
      'Erst nach Zahlung der VISA Gebühren kann Ihr Antrag bearbeitet werden. Bitte wenden Sie sich an die nächste Botschaft oder diplomatische Mission zur Zahlung des Betrages.', // to be translated
    additional: 'Bitte stellen Sie die folgenden Information bereit: ', // to be translated
  },
  downloadPDF: 'Antragsvorschau in PDF',
  confirmPDF:
    'Ich bestätige, dass ich die PDF-Version meines Antrags überprüft habe, insbesondere die',
  biometricPhoto: 'Qualität des eingereichten biometrischen Fotos.',
  submitted: '',
  pleaseChooseFile: 'Bitte wählen Sie eine Datei aus',
  noFileChosen: 'Es wurde keine Datei ausgewählt',
  noUserForEmail:
    'Es wurde kein Benutzer mit dieser E-Mail-Adresse im System gefunden',
  ...terms,
  ...policy,
};



// WEBPACK FOOTER //
// ./src/conf/translations/de.js